import { getJson, withOptional, withDone } from '@rad/utility/http';
// Paginated fetch for property events (curried: filters → pagination → promise)
export const fetchPropertyEventsPage = (refId, search, eventTypes, userIds, dateFrom, dateTo) => (page, pageSize) => withDone(getJson(`/api/properties/events/${refId}`, {
    page, pageSize,
    search: search || undefined,
    eventType: eventTypes.length > 0 ? eventTypes : undefined,
    triggeredBy: userIds.length > 0 ? userIds : undefined,
    dateFrom: dateFrom || undefined,
    dateTo: dateTo || undefined,
}))();
// Paginated fetch for user events (curried: filters → pagination → promise)
export const fetchUserEventsPage = (userId, search, eventTypes, dateFrom, dateTo) => (page, pageSize) => withDone(getJson(`/api/user/${userId}/events`, {
    page, pageSize,
    search: search || undefined,
    eventType: eventTypes.length > 0 ? eventTypes : undefined,
    dateFrom: dateFrom || undefined,
    dateTo: dateTo || undefined,
}))();
// Filter metadata
export const getPropertyEventFilters = (id) => withOptional(getJson(`/api/properties/events/${id}/filters`));
export const getUserEventFilters = (id) => withOptional(getJson(`/api/user/${id}/events/filters`));
